import { createBunWebSocket } from "hono/bun";

import * as wsGateway from "./ws-gateway.js";
import {
  handleNodeProxyWsTunnelClose,
  handleNodeProxyWsTunnelMessage,
  handleNodeProxyWsTunnelOpen,
} from "./server-node-proxy-ws-tunnel.js";

export function createServerWebsocketRuntime() {
  const { upgradeWebSocket, websocket: baseWebsocket } = createBunWebSocket();

  const websocket = {
    ...baseWebsocket,
    open(ws: any) {
      if (handleNodeProxyWsTunnelOpen(ws)) {
        return;
      }
      if (ws.data?.gatewayAppName) {
        wsGateway.handleOpen(ws);
        return;
      }
      baseWebsocket.open?.(ws);
    },
    message(ws: any, msg: any) {
      if (handleNodeProxyWsTunnelMessage(ws, msg)) {
        return;
      }
      if (ws.data?.gatewayAppName) {
        wsGateway.handleMessage(ws, msg);
        return;
      }
      baseWebsocket.message?.(ws, msg);
    },
    close(ws: any, code?: number, reason?: string) {
      if (handleNodeProxyWsTunnelClose(ws, code, reason)) {
        return;
      }
      if (ws.data?.gatewayAppName) {
        wsGateway.handleClose(ws);
        return;
      }
      baseWebsocket.close?.(ws, code, reason);
    },
  };

  return { upgradeWebSocket, websocket };
}
